import { snackbarSlice } from './slice';

export const { openSnackbar, closeSnackbar } = snackbarSlice.actions;
